import React, { ReactNode } from 'react';
import { Text } from 'library';

export default function Paragraph({ children }: { children?: ReactNode | ReactNode[] }) {
    return (
        <div style={{ marginBottom: 40 }}>
            <Text variant="body2">{children}</Text>
        </div>
    );
}
